/* eslint-disable no-console, no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Waiting from "../Waiting";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  CustomRadioButtonNew,
  SearchDropDown,
  // RadioContainer
} from "../CreateEvent/style";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import Editor from "../CKEditor";
import Select from "react-select";
import {
  RecognitionCloseIcon,
  UploadHDMIcon,
  closeIcon,
  DropIcon
  // AddIconBranding
} from "../../utils/icons";
import { getRecipeCategories, addRecipe } from "../../redux/actions";
import { Border } from "../Journeys/styles";
import { withRouter } from 'react-router-dom';
import { ImageUrl } from "../../utils/constants";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import { GetWellbeingPillars } from "../../redux/constants/apiConstants";
import { fetchApi, getMonthName } from "../../utils/methods";

// Custom styles for React Select
const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? null : null,
    "&:hover": {
      borderColor: state.isFocused ? "hsl(0,0%,70%)" : "hsl(0,0%,70%)",
    },
    minHeight: '48px',
    border: '0.75px solid #BDBDBD',
    borderRadius: '4px',
    backgroundColor: 'white'
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#BDBDBD",
    fontFamily: "Lato",
    fontSize: "16px"
  }),
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    color: "#184A61",
    fontFamily: "Lato",
    fontSize: "16px"
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999
  })
};

class CreateRecipe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Step Control
      step: 1,
      buttonStatus: false,
      loading: false,

      // Step 1: About Recipe
      title: "",
      imgSrc: "",
      imageName: "",
      recipeUrl: "",
      description: "",
      charCount: 0,

      // Step 2: Customize (Categories & Theme)
      recipeCategorieslist: [],
      themeId: null,
      month:null,
      themeName: "",
      themeMonth: "",
      selectedThemeOption: 1,
      so: false, // State for dropdown open/close

      // Step 3: Time & Serving
      ampedWith: "",
      servings: "",
      prepTimeHour: "",
      prepTimeMin: "",
      cookTimeOption: 0, // 0 = Input Time, 1 = Refrigerate
      cookTimeHour: "",
      cookTimeMin: "",
      mealType: null,
      skillLevel: null,

      // Step 4: Preparation Details
      nutrients: {
        protein: "",
        calories: "",
        carbs: "",
        fiber: "",
        fat: "",
        sugar: "",
        sodium: "" // --- ADDED SODIUM HERE ---
      },
      tempIngredient: "",
      ingredients: [],
      tempDirection: "",
      directions: [],
      wellbeingPillars:[],
      selectedWellbeingPillar:null

      // UI States
    };
  }

  componentDidMount() {
    this.props.getRecipeCategories();
    this.getAllWellbeingPillars()
  }

  getAllWellbeingPillars = async () => {
    // setIsLoading(true);
    try {
      const res = await fetchApi(GetWellbeingPillars , "GET");

      if (res.status === "success") {
        // setWellbeingPillars(res.data);
        this.setState({wellbeingPillars:res?.data})
        // setIsLoading(false);
      } else {
        toast.error(res.data.message || "Something went wrong");
        // setIsLoading(false);s

      }
    } catch (error) {
      window.console.error(error);
      // setIsLoading(false);
    }
  };

  // --- Navigation & Utility Functions ---

  updateStep = (value) => {
    window.scrollTo(0, 0);
    this.setState({ step: value });
  };

  redirect = () => {

    const{history}=this.props;
    const fromAdmin =history?.location?.state?.route  === "admin";
  
    if (fromAdmin) {
      this.props.history.push("/company/wellness",{ activeTab: "Library",activeLibraryTab: "Recipes"});
    } else {
      this.props.history.goBack();
    }
  };

  isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  // --- Input Handlers ---

  onChangeInput = (e) => {
    const { name, value } = e.target;
    
    // --- CHANGE: Restrict Time fields to 2 digits ---
    const timeFields = ['prepTimeHour', 'prepTimeMin', 'cookTimeHour', 'cookTimeMin'];
    if (timeFields.includes(name)) {
      if (value.length > 2) return;
    }
    // ------------------------------------------------

    this.setState({ [name]: value });
  };

  onChangeNutrient = (e) => {
    const { name, value } = e.target;
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      this.setState((prevState) => ({
        nutrients: {
          ...prevState.nutrients,
          [name]: value
        }
      }));
    }
  };

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const plainText = newContent.replace(/<[^>]*>/g, "").trim();
    this.setState({
      description: newContent,
      charCount: plainText.length
    });
  };

  // --- Image Handling ---

  onImageChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  // --- Category & Selection Handlers ---

  toggleCategory = (id) => {
    const { recipeCategorieslist } = this.state;
    let newList = [...recipeCategorieslist];
    if (newList.includes(id)) {
      newList = newList.filter((item) => item !== id);
    } else {
      newList.push(id);
    }
    this.setState({ recipeCategorieslist: newList });
  };


  MONTH_MAP = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  // onSelectTheme = (selectedItem) => {
  //   // Handle selection from CommonDropdown
  //   // Assuming the dropdown passes the full theme object

  //   const monthNumber = this.MONTH_MAP[selectedItem.month] || null;
  //   if (selectedItem) {
  //     this.setState({
  //       themeName: selectedItem.theme_text,
  //       themeMonth: selectedItem.month,
  //       month: monthNumber
  //     });
  //   }
  // };

  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  // --- List Handlers ---

  addIngredient = () => {
    const { tempIngredient, ingredients } = this.state;
    if (tempIngredient.trim()) {
      this.setState({
        ingredients: [...ingredients, tempIngredient.trim()],
        tempIngredient: ""
      });
    }
  };

  removeIngredient = (index) => {
    const newIngredients = [...this.state.ingredients];
    newIngredients.splice(index, 1);
    this.setState({ ingredients: newIngredients });
  };

  addDirection = () => {
    const { tempDirection, directions } = this.state;
    if (tempDirection.trim()) {
      this.setState({
        directions: [...directions, tempDirection.trim()],
        tempDirection: ""
      });
    }
  };

  removeDirection = (index) => {
    const newDirections = [...this.state.directions];
    newDirections.splice(index, 1);
    this.setState({ directions: newDirections });
  };

  // --- Submission ---

  saveRecipe = () => {
    
    const {
      title, imgSrc, recipeUrl, description,
      recipeCategorieslist,
      ampedWith, servings, prepTimeHour, prepTimeMin, cookTimeOption, cookTimeHour, cookTimeMin, mealType, skillLevel,
      nutrients, ingredients, directions, tempIngredient, tempDirection,selectedWellbeingPillar
    } = this.state;

    const { addRecipe, history } = this.props;
    const fromAdmin =history?.location?.state?.route  === "admin";

    this.setState({ loading: true, buttonStatus: true });

    // Parses 0 if minute string is empty
    const prepMinutes = (parseInt(prepTimeHour || 0, 10) * 60) + parseInt(prepTimeMin || 0, 10);
    const cookMinutes = (parseInt(cookTimeHour || 0, 10) * 60) + parseInt(cookTimeMin || 0, 10);

    // Merge any text currently in the input field into the list (UX fallback)
    const finalIngredients = [...ingredients];
    if (tempIngredient.trim()) finalIngredients.push(tempIngredient.trim());

    const finalDirections = [...directions];
    if (tempDirection.trim()) finalDirections.push(tempDirection.trim());

    const formattedNutrients = {
      protein: Number(nutrients.protein),
      calories: Number(nutrients.calories),
      carbs: Number(nutrients.carbs),
      fiber: Number(nutrients.fiber),
      fat: Number(nutrients.fat),
      sugar: Number(nutrients.sugar),
      sodium: Number(nutrients.sodium)
    };

    const payload = {
      name: title,
      image: imgSrc,
      video_url: recipeUrl,
      description: description,
      category_tags: recipeCategorieslist,
      month: selectedWellbeingPillar?.id,
      title: ampedWith,
      servings: servings,
      prep_time: prepMinutes,
      cook_time_option: cookTimeOption,
      cook_time: cookTimeOption === 0 ? cookMinutes : "Refrigerate Overnight",
      meal_type: mealType?.value,
      level: skillLevel?.value,
      ingredients: finalIngredients,
      directions: finalDirections.map((desc, i) => ({ step: i + 1, description: desc })),
      ...formattedNutrients
    };

    addRecipe(payload, history, fromAdmin);
  };

  // --- Render Helpers ---

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      {this.props.t("Create Recipe")}
    </FormHeading>
  );

  DropdownIndicator = () => (
    <div style={{ paddingRight: 10 }}>{DropIcon("#DA6C74")}</div>
  );

  // --- STEPS ---

  stepOneForm = () => {
    const { title, recipeUrl, description, charCount, imgSrc } = this.state;
    const { t } = this.props;

    return (
      <div className="form">
        <div className="formBody">
          <InputContainer>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>{t("Recipe Title")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter recipe title")}
              name="title"
              onChange={this.onChangeInput}
              value={title}
              maxLength="100"
              bgColor={"white"}
              border={"0.75px solid #BDBDBD"}
            />
            <div className="count">{title?.length}/100 | C</div>
          </InputContainer>

          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

          <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"16px"}>{t("Recipe Thumbnail")}{<span>*</span>}</StyledLabel>
          <CommonImageUploader
            imgSrc={imgSrc}
            t={t}
            closeIcon={closeIcon}
            UploadIcon={UploadHDMIcon}
            onImageChange={this.onImageChange}
            onRemoveImage={this.removePhoto}
          />

          <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />

          <InputContainer>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>{t("Recipe URL")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter recipe URL")}
              name="recipeUrl"
              onChange={this.onChangeInput}
              value={recipeUrl}
              bgColor={"white"}
              border={"0.75px solid #BDBDBD"}
            />
          </InputContainer>

          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

          <InputContainer isColorError={charCount > 3000}>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>{t("Recipe Description")}{<span>*</span>}</StyledLabel>
            <EditorContainer>
              <Editor
                content={description}
                onChange={this.onChangeDescription}
              />
            </EditorContainer>
            <div className="char-count">{charCount}/3000 | C</div>
          </InputContainer>
        </div>
      </div>
    );
  };

  stepTwoForm = () => {
    const { recipeCategorieslist, /*themeName, themeMonth,*/ so, /*month,*/wellbeingPillars,selectedWellbeingPillar } = this.state;
    const { t, recipeCategories, /*themesHeaderAll*/ } = this.props;

    // Prepare data for CommonDropdown
    // const themeOptions = themesHeaderAll && themesHeaderAll.length > 0 
    //   ? themesHeaderAll.map((theme) => ({
    //     ...theme,
    //     displayText: `${theme.month}, ${theme.theme_text}`
    //   }))
    //   : [];

    return (
      <div className="form">
        <div className="formBody">
          <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"} marginb={"12px"}>
            {t("Select category")}{<span>*</span>}
          </StyledLabel>

          <div style={{ display: 'block', marginBottom: '20px' }}>
            {recipeCategories && recipeCategories.map((cat) => (
              <div
                key={cat.id}
                onClick={() => this.toggleCategory(cat.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  border: recipeCategorieslist.includes(cat.id) ? '1px solid #da6c74' : '1px solid #E0E0E0',
                  borderRadius: '24px',
                  cursor: 'pointer',
                  backgroundColor: recipeCategorieslist.includes(cat.id) ? '#da6c74' : 'white',
                  color: recipeCategorieslist.includes(cat.id) ? '#fff' : '#184A61',
                  fontSize: '16px',
                  fontFamily: 'Lato',
                  fontWeight: 400,
                  transition: 'all 0.2s ease-in-out',
                  float: 'left',
                  marginRight: '8px',
                  marginBottom: '12px'
                }}
              >
                <span>{<img src={ImageUrl + "/" + cat.image} alt="" style={{ width: 24, height: 24, marginRight: 8, borderRadius:'50%' }} />}</span>
                <span>{cat.recipe_tag}</span>
              </div>
            ))}
            <div style={{ clear: 'both' }}></div>
          </div>

          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

          {/* Monthly Theme Dropdown - Now Optional */}
          <CommonDropdown
            tileContainerStyle={{ width: "100%", padding: "0px 0px 12px 0px" }}
            dropdownStyle={{ top: "90px" }}
            labelText={t("Monthly theme")} 
            
            dropdownOpen={so}
            placeholder={ wellbeingPillars?.length > 0 ? t("Select monthly theme (optional)") : t("No Themes Available")}
            // title={themeName && themeMonth ? `${themeMonth}, ${themeName}` : ""}
            title={(selectedWellbeingPillar?.pillar_title) ? ` ${getMonthName(selectedWellbeingPillar?.id) + " - " + selectedWellbeingPillar?.pillar_title}` : t('Select theme')}
            id="dropdown-monthly-theme"
            onClick={() => this.setState({ so: !so })}
            data={wellbeingPillars}
            onSelect={this.onSelectTheme}
            // active={themeId}
            // onSelectParameter={["id", "theme_text", "month"]}
            onSelectParameter={['pillar_title','id']}
            // valueString={"Theme"}
            itemValue={true}
            valueIndex={0}
            dropIcon={true}
            labelMargin={"0px"}
            fontSize={"16px"}
            showMonthName={true}
          />

        </div>
      </div>
    );
  };

  stepThreeForm = () => {
    const { ampedWith, servings, prepTimeHour, prepTimeMin, cookTimeHour, cookTimeMin, cookTimeOption, mealType, skillLevel } = this.state;
    const { t } = this.props;

    const mealOptions = ["Breakfast", "Lunch", "Dinner", "Snack", "Dessert"].map((m) => ({ value: m, label: m }));
    const skillOptions = ["Easy - Sous Chef", "Medium - Head Chef", "Hard - Executive Chef"].map((s) => ({ value: s, label: s }));

    return (
      <div className="form">
        <div className="formBody">
          {/* Amped With */}
          <InputContainer>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>{t("Amped with")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter Amped with")}
              name="ampedWith"
              onChange={this.onChangeInput}
              value={ampedWith}
              bgColor={"white"}
              border={"0.75px solid #BDBDBD"}
            />
          </InputContainer>

          <Border style={{ background: '#EFEFEF', margin: '15px 0' }} />

          {/* Servings */}
          <InputContainer>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>{t("Servings")}{<span>*</span>}</StyledLabel>
            <StyledInputV2
              placeholder={t("Enter Servings (Ex: 4)")}
              name="servings"
              type="number"
              onChange={this.onChangeInput}
              value={servings}
              bgColor={"white"}
              border={"0.75px solid #BDBDBD"}
            />
          </InputContainer>

          <Border style={{ background: '#EFEFEF', margin: '15px 0' }} />

          {/* Time Section Grid */}
          <div style={{ display: 'flex', justifyContent: 'inital', marginBottom: '15px' }}>

            {/* Left: Prep Time */}
            <div style={{ width: '40%' }}>
              <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"}>{t("Prep Time")}{<span>*</span>}</StyledLabel>
              <div style={{ display: 'inline-flex', flexDirection: 'row', gap: '15px', marginTop: '12px' }}>
                <div >
                  <div style={{ textAlign: 'center', marginBottom: '5px', fontSize: '16px', color: '#184A61', fontFamily: 'Lato' }}>Hour</div>
                  <StyledInputV2 name="prepTimeHour" value={prepTimeHour} onChange={this.onChangeInput} type="number" placeholder="00" style={{ textAlign: 'center', height: '54px', width: '100px', fontSize: '24px' }} border={"0.75px solid #BDBDBD"} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '28px', fontSize: '20px', color: '#184A61', fontWeight: 'bold' }}>:</div>
                <div >
                  <div style={{ textAlign: 'center', marginBottom: '5px', fontSize: '16px', color: '#184A61', fontFamily: 'Lato' }}>Min</div>
                  <StyledInputV2 name="prepTimeMin" value={prepTimeMin} onChange={this.onChangeInput} type="number" placeholder="00" style={{ textAlign: 'center', height: '54px', width: '100px', fontSize: '24px' }} border={"0.75px solid #BDBDBD"} />
                </div>
              </div>
            </div>

            {/* Right: Cook Time */}
            <div style={{ width: '61%' }}>
              {/* Radio Buttons Row */}
              <div style={{ display: 'flex', gap: '20px', marginBottom: '10px', alignItems: 'center', minHeight: '24px' }}>
                <div onClick={() => this.setState({ cookTimeOption: 0 })} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <CustomRadioButtonNew isChecked={cookTimeOption === 0} background={"#DA6C74"} style={{ marginRight: '8px', width: '22px', height: '18px' }}>
                    {cookTimeOption === 0 && <div />}
                  </CustomRadioButtonNew>
                  <StyledLabel isFont={"16px"} color={"#184A61"} margin="0" symbolSize={"16px"} style={{ cursor: 'pointer', whiteSpace: 'nowrap', marginBottom: '0' }}>
                    {t("Input Cook Time")}{<span>*</span>}
                  </StyledLabel>
                </div>

                <div onClick={() => this.setState({ cookTimeOption: 1 })} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <CustomRadioButtonNew isChecked={cookTimeOption === 1} background={"#DA6C74"} style={{ marginRight: '8px', width: '21px', height: '19px' }}>
                    {cookTimeOption === 1 && <div />}
                  </CustomRadioButtonNew>
                  <StyledLabel isFont={"16px"} color={"#184A61"} margin="0" symbolSize={"13px"} style={{ cursor: 'pointer', whiteSpace: 'nowrap', marginBottom: '0' }}>
                    {t("Refrigerate Overnight or at least 4 hours")}{<span>*</span>}
                  </StyledLabel>
                </div>
              </div>

              {/* Conditional Cook Time Inputs */}
              {cookTimeOption === 0 ? (
                <div style={{ display: 'inline-flex', flexDirection: 'row', gap: '15px' ,marginTop:'12px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ textAlign: 'center', marginBottom: '5px', fontSize: '16px', color: '#184A61', fontFamily: 'Lato' }}>Hour</div>
                    <StyledInputV2 name="cookTimeHour" value={cookTimeHour} onChange={this.onChangeInput} type="number" placeholder="00" style={{ textAlign: 'center', height: '54px', width: '100px', fontSize: '24px' }} border={"0.75px solid #BDBDBD"} />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '28px', fontSize: '20px', color: '#184A61', fontWeight: 'bold' }}>:</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ textAlign: 'center', marginBottom: '5px', fontSize: '16px', color: '#184A61', fontFamily: 'Lato' }}>Min</div>
                    <StyledInputV2 name="cookTimeMin" value={cookTimeMin} onChange={this.onChangeInput} type="number" placeholder="00" style={{ textAlign: 'center', height: '54px', width: '100px', fontSize: '24px' }} border={"0.75px solid #BDBDBD"} />
                  </div>
                </div>
              ) : (
                <div style={{ height: '77px' }}></div>
              )}
            </div>
          </div>

          <Border style={{ background: '#EFEFEF', margin: '15px 0' }} />

          {/* Meal Type & Skill Level Grid */}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '48%' }}>
              <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"} marginb={"12px"}>{t("Meal Type")}{<span>*</span>}</StyledLabel>
              <SearchDropDown style={{ height: "50px", width: '100%' }}>
                <Select
                  options={mealOptions}
                  onChange={(val) => this.setState({ mealType: val })}
                  value={mealType}
                  placeholder={t("Breakfast")}
                  styles={customStyles}
                  components={{ DropdownIndicator: this.DropdownIndicator }}
                />
              </SearchDropDown>
            </div>
            <div style={{ width: '48%' }}>
              <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"} marginb={"12px"}>{t("Skill Level")}{<span>*</span>}</StyledLabel>
              <SearchDropDown style={{ height: "50px", width: '100%' }}>
                <Select
                  options={skillOptions}
                  onChange={(val) => this.setState({ skillLevel: val })}
                  value={skillLevel}
                  placeholder={t("Easy - Sous Chef")}
                  styles={customStyles}
                  components={{ DropdownIndicator: this.DropdownIndicator }}
                />
              </SearchDropDown>
            </div>
          </div>

        </div>
      </div>
    );
  };

  stepFourForm = () => {
    const { nutrients, ingredients, tempIngredient, directions, tempDirection } = this.state;
    const { t } = this.props;

    // Defined units for each field
    // --- ADDED SODIUM TO THIS LIST ---
    const nutrientFields = [
      { key: 'protein', placeholder: 'Enter Amount', unit: 'g' },
      { key: 'carbs', placeholder: 'Enter Amount', unit: 'g' },
      { key: 'fat', placeholder: 'Enter Amount', unit: 'g' },
      { key: 'fiber', placeholder: 'Enter Amount', unit: 'g' },
      { key: 'sugar', placeholder: 'Enter Amount', unit: 'g' },
      { key: 'sodium', placeholder: 'Enter Amount', unit: 'mg' }, 
      { key: 'calories', placeholder: 'Enter Amount', unit: 'kcal' }
    ];

    return (
      <div className="form">
        <div className="formBody">

          {/* Nutrients Grid */}
          <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"} marginb={"12px"}>{t("Add Nutrient Facts")}{<span>*</span>}</StyledLabel>
          <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '15px', width: '100%' }}>
            {nutrientFields.map((nut) => (
              <div key={nut.key} style={{ width: '32%', position: 'relative' }}>
                <StyledInputV2
                  name={nut.key}
                  value={nutrients[nut.key]}
                  onChange={this.onChangeNutrient}
                  placeholder={nut.placeholder}
                  border={"0.75px solid #BDBDBD"}
                  style={{ paddingRight: '40px', color:'#184A61 !important' }}
                />
                <span style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9E9E9E',
                  fontSize: '16px',
                  fontFamily: 'Lato',
                  pointerEvents: 'none'
                }}>
                  <span style={{textTransform:'capitalize', color:'#9E9E9E'}}>{nut.key}</span>&nbsp;|&nbsp;{nut.unit}
                </span>
              </div>
            ))}
          </div>

          <Border style={{ background: '#EFEFEF', margin: '20px 0' }} />

          {/* Ingredients */}
          <InputContainer style={{ position: 'relative', width: '100%' }}>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"} marginb={"12px"}>{t("Ingredients")}{<span>*</span>}</StyledLabel>
            <div style={{ position: 'relative', width: '100%' }}>
              <StyledInputV2
                name="tempIngredient"
                value={tempIngredient}
                onChange={this.onChangeInput}
                placeholder={t("Enter Ingredients list")}
                border={"0.75px solid #BDBDBD"}
                onKeyPress={(e) => e.key === 'Enter' && this.addIngredient()}
                style={{ paddingRight: '40px' }}
              />
              {tempIngredient.length > 0 && (
                <div
                  onClick={this.addIngredient}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    color: '#DA6C74',
                    fontSize: '24px',
                    marginTop: '10px',
                    marginLeft: '5px'
                  }}
                >
                  +
                </div>
              )}
            </div>
          </InputContainer>
          {ingredients.length > 0 && (
            <ul style={{ paddingLeft: 0, color: '#184A61', marginTop: 10, marginBottom: 0 }}>
              {ingredients.map((item, idx) => (
                <li key={idx} style={{
                  marginBottom: 8,
                  listStyle: 'none',
                  border: '1px solid #dcdcdc',
                  width: '100%',
                  padding: '16px 16px',
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  wordBreak: 'break-word'
                }}>
                  <span>{item}</span>
                  <span onClick={() => this.removeIngredient(idx)} style={{ color: '#DA6C74', cursor: 'pointer', fontSize: 18, fontWeight: 'bold' }}>
                    {RecognitionCloseIcon('#DA6C74')}
                  </span>
                </li>
              ))}
            </ul>
          )}

          <Border style={{ background: '#EFEFEF', margin: '20px 0' }} />

          {/* Directions */}
          <InputContainer style={{ position: 'relative', width: '100%' }}>
            <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"16px"} marginb={"12px"}>{t("Directions")}{<span>*</span>}</StyledLabel>
            <div style={{ position: 'relative', width: '100%' }}>
              <StyledInputV2
                name="tempDirection"
                value={tempDirection}
                onChange={this.onChangeInput}
                placeholder={t("Enter direction to prepare")}
                border={"0.75px solid #BDBDBD"}
                onKeyPress={(e) => e.key === 'Enter' && this.addDirection()}
                style={{ paddingRight: '40px' }}
              />
              {tempDirection.length > 0 && (
                <div
                  onClick={this.addDirection}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    color: '#DA6C74',
                    fontSize: '24px',
                    marginTop: '10px',
                    marginLeft: '5px'
                  }}
                >
                  +
                </div>
              )}
            </div>
          </InputContainer>
          {directions.length > 0 && (
            <ul style={{ paddingLeft: 0, color: '#184A61', marginTop: 10, marginBottom: 0 }}>
              {directions.map((item, idx) => (
                <li key={idx} style={{
                  marginBottom: 8,
                  listStyle: 'none',
                  width: '100%'

                }}>
                  <p >Step {idx + 1}</p>

                  <p style={{ border: '1px solid #dcdcdc', padding: '16px 16px', borderRadius: '4px', wordBreak: 'break-word' }} >{item}
                    <span onClick={() => this.removeDirection(idx)} style={{ color: '#DA6C74', cursor: 'pointer', fontSize: 18, fontWeight: 'bold', float: 'right' }}>
                      {RecognitionCloseIcon('#DA6C74')}
                    </span>
                  </p>
                </li>
              ))}
            </ul>
          )}

        </div>
      </div>
    );
  };

  render() {
    const { step, title, imgSrc, description, recipeCategorieslist,  ampedWith, servings, prepTimeHour, prepTimeMin, cookTimeHour, cookTimeMin, cookTimeOption, mealType, skillLevel, ingredients, directions, loading, nutrients, tempIngredient, tempDirection, recipeUrl } = this.state;
    const { recipeLoading } = this.props;

    if (recipeLoading || loading) {
      return <Waiting />;
    }

    // --- Validation Logic ---

    // Step 1 validation logic to include recipeUrl requirement and validity check
    const step1Valid = title && imgSrc && description && recipeUrl && this.isValidUrl(recipeUrl);
    
    // --- CHANGE: Added validation for themeId ---
    const step2Valid = recipeCategorieslist.length > 0 ;
    // --------------------------------------------

    const step3Valid =
      ampedWith &&
      servings &&
      (prepTimeHour !== "" || prepTimeMin !== "") && // <--- CHANGED: Requires either Hour OR Min
      (cookTimeOption === 1 || (cookTimeHour !== "" || cookTimeMin !== "")) && // <--- CHANGED: Requires either Hour OR Min
      mealType &&
      skillLevel;

    // Check if nutrients are filled. Check if lists are populated OR if the user has typed something in the input
    const allNutrientsFilled = Object.values(nutrients).every((val) => val !== "");
    const step4Valid =
      allNutrientsFilled &&
      (ingredients.length > 0 || tempIngredient) &&
      (directions.length > 0 || tempDirection);

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            {/* Sidebar Navigation */}
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-recipe" />
            </div>

            {/* Active Step Form Content */}
            {step === 1 ? this.stepOneForm() :
              step === 2 ? this.stepTwoForm() :
                step === 3 ? this.stepThreeForm() :
                  this.stepFourForm()
            }
          </Container>
        </div>

        {/* Footer Buttons */}
        {step === 1 ? (
          <ButtonContainer style={{ left: '75px' }}>
            <div className="wrapper" style={{ justifyContent: 'flex-end' }}>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={!step1Valid}
                onClick={!step1Valid ? null : () => this.updateStep(2)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer style={{ left: '75px' }}>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(1)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={!step2Valid}
                onClick={!step2Valid ? null : () => this.updateStep(3)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : step === 3 ? (
          <ButtonContainer style={{ left: '75px' }}>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(2)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={!step3Valid}
                onClick={!step3Valid ? null : () => this.updateStep(4)}
              >
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : (
          <ButtonContainer style={{ left: '75' }}>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px" onClick={() => this.updateStep(3)} margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup
                height="48px"
                width="200px"
                margin="auto 0 auto auto"
                disabled={!step4Valid}
                onClick={!step4Valid ? null : () => this.saveRecipe()}
              >
                Create
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
      </Layout>
    );
  }
}

CreateRecipe.propTypes = {
  getRecipeCategories: PropTypes.func,
  addRecipe: PropTypes.func,
  recipeCategories: PropTypes.array,
  recipeLoading: PropTypes.bool,
  themesHeaderAll: PropTypes.array,
  history: PropTypes.object,
  isAdminRoute: PropTypes.bool,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  recipeCategories: state.education.recipeCategories,
  recipeLoading: state.education.recipeLoading,
  // themesHeaderAll: state.challenges.themesHeaderAll || [],
});

const mapDispatchToProps = (dispatch) => ({
  getRecipeCategories: () => dispatch(getRecipeCategories()),
  addRecipe: (data, history, isAdminRoute) => dispatch(addRecipe(data, history, isAdminRoute)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(CreateRecipe)));